export const setChannelListenerWs = (payload) => ({
  type: 'CHANNEL_LISTENER_WS',
  payload,
});
